// extracted by mini-css-extract-plugin
export default {"container":"TextareaWithCounter_container__Wylhr","input":"TextareaWithCounter_input__F5z8b","counter":"TextareaWithCounter_counter__X6pYl"};